import React from 'react';

// SP8-W0: the spinner in the STARS look (states.html "Loading"): a 32px ring in the
// divider colour with an action-colour arc, centred in the space it is given.
// No role: many screens own a role="status" line of their own (data-slot is the hook).
const Loader = () => {
  return (
    <div data-slot="loader" className="tw-grid tw-min-h-48 tw-w-full tw-place-items-center">
      <div className="tw-h-8 tw-w-8 tw-animate-spin tw-rounded-pill tw-border-4 tw-border-solid tw-border-divider tw-border-t-action motion-reduce:tw-animate-none" />
    </div>
  );
};

export default Loader;
